import React, { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import EnvironmentTitle from './EnvironmentTitle'

function Login() {
  const [loginMode, setLoginMode] = useState('admin')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [employeeId, setEmployeeId] = useState('')
  const [pin, setPin] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const { login, loginEmployee } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const returnTo = location.state?.from || '/'

  async function handleAdminSubmit(e) {
    e.preventDefault()
    setLoading(true)
    setError(null)

    const result = await login(email, password)

    if (result.success) {
      navigate(returnTo)
    } else {
      setError(result.error || 'Login failed')
    }

    setLoading(false)
  }

  async function handleEmployeeSubmit(e) {
    e.preventDefault()
    setLoading(true)
    setError(null)

    const result = await loginEmployee(employeeId, pin)

    if (result.success) {
      navigate(returnTo)
    } else {
      setError(result.error || 'Login failed')
    }

    setLoading(false)
  }

  function switchMode(mode) {
    setLoginMode(mode)
    setError(null)
  }

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-logo">
          <div className="login-title"><EnvironmentTitle /></div>
          <div className="login-subtitle">Unified Operations Platform</div>
        </div>

        <div className="login-tabs">
          <button
            type="button"
            className={`login-tab ${loginMode === 'admin' ? 'login-tab-active' : ''}`}
            onClick={() => switchMode('admin')}
          >
            Admin Login
          </button>
          <button
            type="button"
            className={`login-tab ${loginMode === 'employee' ? 'login-tab-active' : ''}`}
            onClick={() => switchMode('employee')}
          >
            Employee Login
          </button>
        </div>

        {error && (
          <div className="login-error">
            {error}
          </div>
        )}

        {loginMode === 'admin' ? (
          <form onSubmit={handleAdminSubmit}>
            <div className="form-group">
              <label className="form-label" htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                className="form-input"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
                autoFocus
              />
            </div>

            <div className="form-group">
              <label className="form-label" htmlFor="password">Password</label>
              <input
                id="password"
                type="password"
                className="form-input"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="Enter your password"
                required
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary btn-lg"
              style={{ width: '100%' }}
              disabled={loading}
            >
              {loading ? (
                <span className="loading-spinner" style={{ width: 20, height: 20 }} />
              ) : (
                'Sign In'
              )}
            </button>
          </form>
        ) : (
          <form onSubmit={handleEmployeeSubmit}>
            <div className="form-group">
              <label className="form-label" htmlFor="employeeId">Employee ID</label>
              <input
                id="employeeId"
                type="text"
                className="form-input"
                value={employeeId}
                onChange={e => setEmployeeId(e.target.value.toUpperCase())}
                placeholder="E001"
                pattern="E\d{3,}"
                required
                autoFocus
              />
            </div>

            <div className="form-group">
              <label className="form-label" htmlFor="pin">PIN</label>
              <input
                id="pin"
                type="password"
                className="form-input"
                value={pin}
                onChange={e => setPin(e.target.value.replace(/\D/g, '').slice(0, 10))}
                placeholder="Enter your PIN"
                inputMode="numeric"
                minLength={6}
                maxLength={10}
                required
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary btn-lg"
              style={{ width: '100%' }}
              disabled={loading}
            >
              {loading ? (
                <span className="loading-spinner" style={{ width: 20, height: 20 }} />
              ) : (
                'Sign In'
              )}
            </button>
          </form>
        )}
      </div>

      <style>{`
        .login-tabs {
          display: flex;
          gap: 0;
          margin-bottom: 1.5rem;
          border-bottom: 2px solid var(--border-color, #e2e8f0);
        }
        .login-tab {
          flex: 1;
          padding: 0.75rem 1rem;
          border: none;
          background: none;
          cursor: pointer;
          font-size: 0.875rem;
          font-weight: 500;
          color: var(--text-secondary, #64748b);
          border-bottom: 2px solid transparent;
          margin-bottom: -2px;
          transition: color 0.2s, border-color 0.2s;
        }
        .login-tab:hover {
          color: var(--text-primary, #1e293b);
        }
        .login-tab-active {
          color: var(--primary-color, #3b82f6);
          border-bottom-color: var(--primary-color, #3b82f6);
        }
      `}</style>
    </div>
  )
}

export default Login
